import { Link } from "react-router-dom";
import { Linkedin, Twitter, Youtube, ArrowUpRight } from "lucide-react";

const COLS = [
  {
    heading: "Navigation",
    links: [
      { label: "Home", to: "/" },
      { label: "Features", to: "/features" },
      { label: "Membership", to: "/membership" },
      { label: "Resources", to: "/resources" },
    ],
  },
  {
    heading: "Membership",
    links: [
      { label: "Free", to: "/membership" },
      { label: "Standard", to: "/membership" },
      { label: "Premium", to: "/membership" },
      { label: "Join Hub", to: "/join" },
    ],
  },
  {
    heading: "Resources",
    links: [
      { label: "Startup", to: "/resources" },
      { label: "Growth", to: "/resources" },
      { label: "Marketing", to: "/resources" },
      { label: "Funding", to: "/resources" },
    ],
  },
  {
    heading: "Legal",
    links: [
      { label: "Privacy", to: "/login" },
      { label: "Terms", to: "/login" },
      { label: "Contact", to: "/contact" },
    ],
  },
];

const SOCIALS = [
  { Icon: Linkedin, label: "LinkedIn" },
  { Icon: Twitter, label: "Twitter" },
  { Icon: Youtube, label: "YouTube" },
];

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative z-10 border-t border-[color:var(--hairline)] bg-[color:var(--surface)]"
    >
      <div className="container-hub py-16 lg:py-20">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <img
              src="/assets/stupeco-logo.png"
              alt="StUpEco Hub"
              className="h-8 w-auto"
              draggable="false"
            />
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-[color:var(--ink-soft)]">
              The business growth network within the StUpEco ecosystem — where
              founders, businesses, professionals, investors and growth partners
              discover, connect, collaborate and grow together.
            </p>
            <Link
              to="/join"
              data-testid="footer-join-cta"
              className="group mt-7 inline-flex items-center gap-1.5 rounded-full bg-[color:var(--invert-bg)] px-5 py-2.5 text-sm font-semibold text-white transition-transform duration-200 hover:-translate-y-0.5"
            >
              Join the early-access list
              <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-4 lg:col-span-7">
            {COLS.map((col) => (
              <div key={col.heading}>
                <h3 className="text-xs font-semibold uppercase tracking-[0.16em] text-[color:var(--ink)]">
                  {col.heading}
                </h3>
                <ul className="mt-4 space-y-3">
                  {col.links.map((l) => (
                    <li key={l.label}>
                      <Link
                        to={l.to}
                        className="text-sm text-[color:var(--ink-soft)] transition-colors hover:text-[color:var(--ink)]"
                      >
                        {l.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="brand-bar mt-14 h-px w-full opacity-30" />

        <div className="mt-6 flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-center">
          <p className="text-xs text-[color:var(--ink-soft)]">
            © {new Date().getFullYear()} StUpEco Hub. All rights reserved.
          </p>
          <div className="flex items-center gap-3">
            {SOCIALS.map(({ Icon, label }) => (
              <a
                key={label}
                href="#"
                aria-label={label}
                data-testid={`footer-social-${label.toLowerCase()}`}
                className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-[color:var(--hairline)] text-[color:var(--ink-soft)] transition-colors hover:border-[color:var(--ink)] hover:text-[color:var(--ink)]"
              >
                <Icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
